import { useQuery } from 'react-query'
import { Session, SessionType } from '@chilipiper/models'
import { bookingLinkService } from './services'
import { BookingLinksListType, ApiBookingLink, BookingLinksGroupBy } from './types'

// This is not the most reliable way of getting groupTemplateId but we have BE task to return this data from API
// https://floatingapps.atlassian.net/browse/CPP-2608
export const getGroupTemplateId = (link?: string) => {
  return link?.split('/').slice(-1)[0]
}

export const useUserBookingLinks = (
  userId?: string,
  listType: BookingLinksListType = BookingLinksListType.All,
  session: SessionType = Session
) => {
  const { data: bookingLinks, isLoading } = useQuery(['userBookingLinks', userId, listType], () => {
    switch (listType) {
      case BookingLinksListType.CreatedByMe:
        return bookingLinkService
          .all({ userId })
          .then(links => links.filter(link => link.createdBy?.id === userId))

      case BookingLinksListType.SharedWithMe:
        return bookingLinkService
          .all({ userId })
          .then(links => links.filter(link => isLinkSharedWithMe(link, session)))

      case BookingLinksListType.All:
      default:
        return bookingLinkService.all({ userId })
    }
  })
  return { bookingLinks, isLoading }
}

export const isLinkSharedWithMe = (bookingLink: ApiBookingLink, session: SessionType = Session) =>
  bookingLink.createdBy?.id !== session.user().id

export const getLinkForCurrentUser = (
  bookingLink: ApiBookingLink,
  session: SessionType = Session
) => {
  if (bookingLink.link) {
    return bookingLink.link
  }

  if (bookingLink.links) {
    const currentUserId = session.user().id
    const currentUserLink = bookingLink.links.find(link => link.userId === currentUserId)
    return currentUserLink?.path
  }
}

export const getBookingLinksGrouped = (
  visibleBookingLinks: ApiBookingLink[],
  groupBy: BookingLinksGroupBy
) => {
  const createOrPushByProp = <T extends object>(item: T, acc: Record<string, T[]>, prop?: any) => {
    if (acc[prop]) {
      acc[prop].push(item)
    } else {
      acc[prop] = [item]
    }
  }
  return visibleBookingLinks.reduce((acc, link) => {
    switch (groupBy) {
      case BookingLinksGroupBy.Workspace: {
        const workspaceKey = link.isPersonal || !link.workspaceId ? 'Personal' : link.workspaceId
        createOrPushByProp(link, acc, workspaceKey)
        break
      }

      case BookingLinksGroupBy.Duration:
        createOrPushByProp(link, acc, link.duration)
        break

      case BookingLinksGroupBy.ContactMethod:
        if (!link.contactMethods.length) {
          createOrPushByProp(link, acc, 'No contact method')
        } else {
          link.contactMethods.forEach(contactMethod => {
            createOrPushByProp(link, acc, contactMethod)
          })
        }
    }

    return acc
  }, {} as Record<string, ApiBookingLink[]>)
}
